<template>
  <v-card
    elevation="12"
    class="pa-4 black--text"
    style="background: white !important; width: 100%"
  >
    <v-card-title>
      <h2>Forgot Password</h2>
    </v-card-title>
    <v-card-text class="no-left-pad-md">
      <template v-if="submitted">
        <v-alert type="success" outlined>
          If an account exists for <strong>{{ submittedEmail }}</strong> you’ll receive a password
          reset email within a few minutes. Check your inbox — and your spam folder — for a
          message from <strong>noreply@impact-hq.org</strong>.
        </v-alert>
        <p class="mt-4">
          Didn’t get the email? You can
          <a href="#" @click.prevent="resetForm">try a different email address</a>, or
          <router-link to="/contact">contact us</router-link> for help.
        </p>
        <v-btn class="main-btn mt-2" to="/auth/login">Back to Sign In</v-btn>
      </template>
      <v-form v-else v-on:submit.prevent="submitForgotPassword">
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Email"
              name="email"
              type="text"
              outlined
              dense
              :disabled="sending"
              v-validate.disable="'required'"
              :error-messages="errors.collect('Email')"
              data-vv-name="Email"
              required
              autocomplete="off"
              v-model="email"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              :disabled="sending"
              type="submit"
              :loading="sending"
              class="main-btn"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss"></style>

<script>
import logo from "../../assets/images/logo.png";
import Vue from "vue";

export default {
  name: "forgotPassword",
  data() {
    return {
      logo: logo,
      email: null,
      sending: false,
      submitted: false,
      submittedEmail: null,
    };
  },
  methods: {
    resetForm() {
      this.submitted = false;
      this.submittedEmail = null;
      this.email = null;
    },
    async submitForgotPassword() {
      let result;
      try {
        result = await this.$validator.validateAll();
        if (!result) {
          return result;
        }
      } catch (err) {
        return;
      }

      if (!result) {
        Vue.$eventBus.$emit("notifyUser", "Fix the invalid fields");
        return false;
      }

      this.sending = true;

      try {
        // Strapi returns 200 whether or not the email is registered, so we always show
        // the same confirmation. Any thrown error here is a transport-level failure.
        await Vue.$userService.forgot(this.email);
        this.submittedEmail = this.email;
        this.submitted = true;
      } catch (err) {
        Vue.$eventBus.$emit("notifyUser", "We couldn’t reach the server. Please try again.");
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
